
<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('forecastDelete') }}</h5>
                    <button type="button" class="btn-close" data-dismiss="modal" @click="close" aria-label="Close" />
                </div>
                <div class="modal-body">
                    <p style="margin-bottom:0">{{ $t('wannaDeleteThisForecast') }}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                        {{ $t('close') }}
                    </button>
                    <button type="button" class="btn btn-primary" @click="deleteForecast" >
                        {{ $t('delete') }}
                    </button>
                </div>
                </div>
            </div>
        </div>      
    </transition>
</template>

<script>
import ForecastApi from "../../api/server/forecast";

export default {
    name: "ForecastDeleteModal",
    methods: {
        close() {
            this.$emit("closeDeleteDialog");
        },
        async deleteForecast() {
            await ForecastApi.forecastDelete(this.$parent.$route.params.id, this.$parent.$route.params.forecastId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    }
};
</script>